import { getRumInstance } from 'src/rum';
import { logger } from 'src/logger';

/**
 * Reports an error to all observability backends (RUM + Katal logger).
 * Call this from ErrorBoundary componentDidCatch, mutation onError, or anywhere
 * an unexpected error needs to be tracked.
 *
 * RUM: routed through the app's Midway-based RUM instance (src/rum).
 * SharedReactLib's recordError() is not used here because its module-level
 * instance is initialized via Cognito initRum(), which this app does not
 * use — it authenticates RUM with Midway credentials instead.
 */
export function reportError(error: unknown, context?: Record<string, unknown>): void {
  const err = error instanceof Error ? error : new Error(String(error));

  // Log to Katal
  void logger.error(err.message, { ...context, stack: err.stack });

  // Record in RUM (no-op if RUM not initialized)
  void getRumInstance().then((rum) => {
    rum?.recordError(err);
  });
}
